import { __extends } from "tslib";
import { WindowManager } from './WindowManager';
var NewWindowManager = /** @class */ (function (_super) {
    __extends(NewWindowManager, _super);
    function NewWindowManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NewWindowManager.prototype.create = function (params) {
        var target = window.open(params.src);
        if (!target) {
            throw new Error('Cannot open window');
        }
        return target;
    };
    NewWindowManager.prototype.getOpenerWindow = function () {
        return window.opener;
    };
    return NewWindowManager;
}(WindowManager));
export { NewWindowManager };
//# sourceMappingURL=NewWindowManager.js.map